

import type { ICountries } from '../types/phone_input';

import { Globe } from '@unified-checkout/design-system/icons/index';
import {
  AF, AL, DZ, AS, AD, AO, AI, AR, AM, AW, AU, AT, AZ,
  BS, BH, BD, BY, BE, BJ, BT, BO, BA, BW, BR,
  BN, BG, BF, BI, KH, CM, CA, KY, CF, TD, CL, CN, CO,
  KM, CR, HR, CU, CW, CY, CZ, CD, DK, DJ, DM, DO, EC, EG, SV,
  GQ, ER, EE, SZ, ET, FO, FI, FR, PF, GA, GM, GE, DE, GH,
  GR, GL, GD, GU, GT, GG, GN, GW, GY, HT, HN, HU, IS, IN,
  ID, IR, IQ, IE, IT, JM, JP, JE, JO, KZ, KE, KI, KW,
  LV, LB, LS, LR, LY, LI, LT, LU, MG, MW, MY, MV, ML, MT,
  MR, MU, MX, FM, MD, MC, MN, ME, MS, MA, MZ, MM, NA, NR, NP,
  NL, NZ, NI, NE, NG, NU, KP, MP, NO, OM, PK, PW, PS, PA,
  PG, PY, PE, PH, PN, PL, PT, PR, QA, RO, RU, RW, BL, LC,
  WS, SM, SA, SN, RS, SC, SL, SG, SX, SK, SI, SO, ZA, KR, SS,
  ES, LK, SR, SE, CH, SY, TW, TJ, TZ, TH, TG, TK, TO, TT,
  TN, TR, TM, TV, UG, UA, AE, GB, US, UY, UZ, VU, VE, VN,
  YE, ZM, ZW,
} from '../assets/Icons/countries';


export const ALL_COUNTRIES_INFO: ICountries = {
  // eg: {
  //   name: 'Egypt',
  //   name_ar: 'مصر',
  //   countryIso2: 'eg',
  //   countryIso3: 'EGY',
  //   countryCode: '+2',
  //   phoneLength: 11,
  //   icon: EG,
  // },
  // ae: {
  //   name: 'United Arab Emirates',
  //   name_ar: 'الإمارات العربية المتحدة',
  //   countryIso2: 'ae',
  //   countryIso3: 'ARE',
  //   countryCode: '+971',
  //   phoneLength: 9,
  //   icon: AE,
  // },
  // sa: {
  //   name: 'Saudi Arabia',
  //   name_ar: 'المملكة العربية السعودية',
  //   countryIso2: 'sa',
  //   countryIso3: 'SAU',
  //   countryCode: '+966',
  //   phoneLength: 9,
  //   icon: SA,
  // },
  // om: {
  //   name: 'Oman',
  //   name_ar: 'عمان',
  //   countryIso2: 'om',
  //   countryIso3: 'OMN',
  //   countryCode: '+968',
  //   phoneLength: 8,
  //   icon: OM,
  // },
  af: {
    name: "Afghanistan",
    name_ar: "أفغانستان",
    countryIso2: "af",
    countryIso3: "AFG",
    countryCode: "+93",
    phoneLength: 9,
    icon: AF,
  },
  al: {
    name: "Albania",
    name_ar: "ألبانيا",
    countryIso2: "al",
    countryIso3: "ALB",
    countryCode: "+355",
    phoneLength: 9,
    icon: AL,
  },
  dz: {
    name: "Algeria",
    name_ar: "الجزائر",
    countryIso2: "dz",
    countryIso3: "DZA",
    countryCode: "+213",
    phoneLength: 9,
    icon: DZ,
  },
  as: {
    name: "American Samoa",
    name_ar: "ساموا الأمريكية",
    countryIso2: "as",
    countryIso3: "ASM",
    countryCode: "+1",
    phoneLength: 10,
    icon: AS,
  },
  ad: {
    name: "Andorra",
    name_ar: "أندورا",
    countryIso2: "ad",
    countryIso3: "AND",
    countryCode: "+376",
    phoneLength: 9,
    icon: AD,
  },
  ao: {
    name: "Angola",
    name_ar: "أنغولا",
    countryIso2: "ao",
    countryIso3: "AGO",
    countryCode: "+244",
    phoneLength: 9,
    icon: AO,
  },
  ai: {
    name: "Anguilla",
    name_ar: "أنغويلا",
    countryIso2: "ai",
    countryIso3: "AIA",
    countryCode: "+1",
    phoneLength: 10,
    icon: AI,
  },
  ar: {
    name: "Argentina",
    name_ar: "الأرجنتين",
    countryIso2: "ar",
    countryIso3: "ARG",
    countryCode: "+54",
    phoneLength: 11,
    icon: AR,
  },
  am: {
    name: "Armenia",
    name_ar: "أرمينيا",
    countryIso2: "am",
    countryIso3: "ARM",
    countryCode: "+374",
    phoneLength: 8,
    icon: AM,
  },
  aw: {
    name: "Aruba",
    name_ar: "أروبا",
    countryIso2: "aw",
    countryIso3: "ABW",
    countryCode: "+297",
    phoneLength: 7,
    icon: AW,
  },
  au: {
    name: "Australia",
    name_ar: "أستراليا",
    countryIso2: "au",
    countryIso3: "AUS",
    countryCode: "+61",
    phoneLength: 9,
    icon: AU,
  },
  at: {
    name: "Austria",
    name_ar: "النمسا",
    countryIso2: "at",
    countryIso3: "AUT",
    countryCode: "+43",
    phoneLength: 11,
    icon: AT,
  },
  az: {
    name: "Azerbaijan",
    name_ar: "أذربيجان",
    countryIso2: "az",
    countryIso3: "AZE",
    countryCode: "+994",
    phoneLength: 9,
    icon: AZ,
  },
  bs: {
    name: "Bahamas",
    name_ar: "جزر البهاما",
    countryIso2: "bs",
    countryIso3: "BHS",
    countryCode: "+1",
    phoneLength: 10,
    icon: BS,
  },
  bh: {
    name: "Bahrain",
    name_ar: "البحرين",
    countryIso2: "bh",
    countryIso3: "BHR",
    countryCode: "+973",
    phoneLength: 8,
    icon: BH,
  },
  bd: {
    name: "Bangladesh",
    name_ar: "بنغلاديش",
    countryIso2: "bd",
    countryIso3: "BGD",
    countryCode: "+880",
    phoneLength: 10,
    icon: BD,
  },
  by: {
    name: "Belarus",
    name_ar: "بيلاروس",
    countryIso2: "by",
    countryIso3: "BLR",
    countryCode: "+375",
    phoneLength: 9,
    icon: BY,
  },
  be: {
    name: "Belgium",
    name_ar: "بلجيكا",
    countryIso2: "be",
    countryIso3: "BEL",
    countryCode: "+32",
    phoneLength: 9,
    icon: BE,
  },
  bj: {
    name: "Benin",
    name_ar: "بنين",
    countryIso2: "bj",
    countryIso3: "BEN",
    countryCode: "+229",
    phoneLength: 10,
    icon: BJ,
  },
  bt: {
    name: "Bhutan",
    name_ar: "بوتان",
    countryIso2: "bt",
    countryIso3: "BTN",
    countryCode: "+975",
    phoneLength: 8,
    icon: BT,
  },
  bo: {
    name: "Bolivia",
    name_ar: "بوليفيا",
    countryIso2: "bo",
    countryIso3: "BOL",
    countryCode: "+591",
    phoneLength: 8,
    icon: BO,
  },
  ba: {
    name: "Bosnia and Herzegovina",
    name_ar: "البوسنة والهرسك",
    countryIso2: "ba",
    countryIso3: "BIH",
    countryCode: "+387",
    phoneLength: 9,
    icon: BA,
  },
  bw: {
    name: "Botswana",
    name_ar: "بوتسوانا",
    countryIso2: "bw",
    countryIso3: "BWA",
    countryCode: "+267",
    phoneLength: 8,
    icon: BW,
  },
  br: {
    name: "Brazil",
    name_ar: "البرازيل",
    countryIso2: "br",
    countryIso3: "BRA",
    countryCode: "+55",
    phoneLength: 11,
    icon: BR,
  },
  bn: {
    name: "Brunei Darussalam",
    name_ar: "بروناي",
    countryIso2: "bn",
    countryIso3: "BRN",
    countryCode: "+673",
    phoneLength: 7,
    icon: BN,
  },
  bg: {
    name: "Bulgaria",
    name_ar: "بلغاريا",
    countryIso2: "bg",
    countryIso3: "BGR",
    countryCode: "+359",
    phoneLength: 9,
    icon: BG,
  },
  bf: {
    name: "Burkina Faso",
    name_ar: "بوركينا فاسو",
    countryIso2: "bf",
    countryIso3: "BFA",
    countryCode: "+226",
    phoneLength: 8,
    icon: BF,
  },
  bi: {
    name: "Burundi",
    name_ar: "بوروندي",
    countryIso2: "bi",
    countryIso3: "BDI",
    countryCode: "+257",
    phoneLength: 8,
    icon: BI,
  },
  cv: {
    name: "Cabo Verde",
    name_ar: "الرأس الأخضر",
    countryIso2: "cv",
    countryIso3: "CPV",
    countryCode: "+238",
    phoneLength: 7,
    icon: Globe,
  },
  kh: {
    name: "Cambodia",
    name_ar: "كمبوديا",
    countryIso2: "kh",
    countryIso3: "KHM",
    countryCode: "+855",
    phoneLength: 9,
    icon: KH,
  },
  cm: {
    name: "Cameroon",
    name_ar: "الكاميرون",
    countryIso2: "cm",
    countryIso3: "CMR",
    countryCode: "+237",
    phoneLength: 9,
    icon: CM,
  },
  ca: {
    name: "Canada",
    name_ar: "كندا",
    countryIso2: "ca",
    countryIso3: "CAN",
    countryCode: "+1",
    phoneLength: 10,
    icon: CA,
  },
  ky: {
    name: "Cayman Islands",
    name_ar: "جزر كايمان",
    countryIso2: "ky",
    countryIso3: "CYM",
    countryCode: "+1",
    phoneLength: 10,
    icon: KY,
  },
  cf: {
    name: "Central African Republic",
    name_ar: "جمهورية أفريقيا الوسطى",
    countryIso2: "cf",
    countryIso3: "CAF",
    countryCode: "+236",
    phoneLength: 8,
    icon: CF,
  },
  td: {
    name: "Chad",
    name_ar: "تشاد",
    countryIso2: "td",
    countryIso3: "TCD",
    countryCode: "+235",
    phoneLength: 8,
    icon: TD,
  },
  cl: {
    name: "Chile",
    name_ar: "تشيلي",
    countryIso2: "cl",
    countryIso3: "CHL",
    countryCode: "+56",
    phoneLength: 9,
    icon: CL,
  },
  cn: {
    name: "China",
    name_ar: "الصين",
    countryIso2: "cn",
    countryIso3: "CHN",
    countryCode: "+86",
    phoneLength: 11,
    icon: CN,
  },
  co: {
    name: "Colombia",
    name_ar: "كولومبيا",
    countryIso2: "co",
    countryIso3: "COL",
    countryCode: "+57",
    phoneLength: 10,
    icon: CO,
  },
  km: {
    name: "Comoros",
    name_ar: "جزر القمر",
    countryIso2: "km",
    countryIso3: "COM",
    countryCode: "+269",
    phoneLength: 7,
    icon: KM,
  },
  cd: {
    name: "Congo",
    name_ar: "الكونغو",
    countryIso2: "cd",
    countryIso3: "COD",
    countryCode: "+243",
    phoneLength: 9,
    icon: CD,
  },
  cr: {
    name: "Costa Rica",
    name_ar: "كوستاريكا",
    countryIso2: "cr",
    countryIso3: "CRI",
    countryCode: "+506",
    phoneLength: 8,
    icon: CR,
  },
  hr: {
    name: "Croatia",
    name_ar: "كرواتيا",
    countryIso2: "hr",
    countryIso3: "HRV",
    countryCode: "+385",
    phoneLength: 9,
    icon: HR,
  },
  cu: {
    name: "Cuba",
    name_ar: "كوبا",
    countryIso2: "cu",
    countryIso3: "CUB",
    countryCode: "+53",
    phoneLength: 8,
    icon: CU,
  },
  cw: {
    name: "Curaçao",
    name_ar: "كوراساو",
    countryIso2: "cw",
    countryIso3: "CUW",
    countryCode: "+599",
    phoneLength: 8,
    icon: CW,
  },
  cy: {
    name: "Cyprus",
    name_ar: "قبرص",
    countryIso2: "cy",
    countryIso3: "CYP",
    countryCode: "+357",
    phoneLength: 8,
    icon: CY,
  },
  cz: {
    name: "Czechia",
    name_ar: "التشيك",
    countryIso2: "cz",
    countryIso3: "CZE",
    countryCode: "+420",
    phoneLength: 9,
    icon: CZ,
  },
  ci: {
    name: "Côte d'Ivoire",
    name_ar: "ساحل العاج",
    countryIso2: "ci",
    countryIso3: "CIV",
    countryCode: "+225",
    phoneLength: 10,
    icon: Globe,
  },
  dk: {
    name: "Denmark",
    name_ar: "الدانمرك",
    countryIso2: "dk",
    countryIso3: "DNK",
    countryCode: "+45",
    phoneLength: 8,
    icon: DK,
  },
  dj: {
    name: "Djibouti",
    name_ar: "جيبوتي",
    countryIso2: "dj",
    countryIso3: "DJI",
    countryCode: "+253",
    phoneLength: 8,
    icon: DJ,
  },
  dm: {
    name: "Dominica",
    name_ar: "دومينيكا",
    countryIso2: "dm",
    countryIso3: "DMA",
    countryCode: "+1",
    phoneLength: 10,
    icon: DM,
  },
  do: {
    name: "Dominican Republic",
    name_ar: "جمهورية الدومينيكان",
    countryIso2: "do",
    countryIso3: "DOM",
    countryCode: "+1",
    phoneLength: 10,
    icon: DO,
  },
  ec: {
    name: "Ecuador",
    name_ar: "الإكوادور",
    countryIso2: "ec",
    countryIso3: "ECU",
    countryCode: "+593",
    phoneLength: 9,
    icon: EC,
  },
  eg: {
    name: "Egypt",
    name_ar: "مصر",
    countryIso2: "eg",
    countryIso3: "EGY",
    countryCode: "+2",
    phoneLength: 11,
    icon: EG,
  },
  sv: {
    name: "El Salvador",
    name_ar: "السلفادور",
    countryIso2: "sv",
    countryIso3: "SLV",
    countryCode: "+503",
    phoneLength: 8,
    icon: SV,
  },
  gq: {
    name: "Equatorial Guinea",
    name_ar: "غينيا الاستوائية",
    countryIso2: "gq",
    countryIso3: "GNQ",
    countryCode: "+240",
    phoneLength: 9,
    icon: GQ,
  },
  er: {
    name: "Eritrea",
    name_ar: "إريتريا",
    countryIso2: "er",
    countryIso3: "ERI",
    countryCode: "+291",
    phoneLength: 7,
    icon: ER,
  },
  ee: {
    name: "Estonia",
    name_ar: "إستونيا",
    countryIso2: "ee",
    countryIso3: "EST",
    countryCode: "+372",
    phoneLength: 8,
    icon: EE,
  },
  sz: {
    name: "Eswatini",
    name_ar: "إسواتيني",
    countryIso2: "sz",
    countryIso3: "SWZ",
    countryCode: "+268",
    phoneLength: 8,
    icon: SZ,
  },
  et: {
    name: "Ethiopia",
    name_ar: "إثيوبيا",
    countryIso2: "et",
    countryIso3: "ETH",
    countryCode: "+251",
    phoneLength: 9,
    icon: ET,
  },
  fo: {
    name: "Faroe Islands",
    name_ar: "جزر فارو",
    countryIso2: "fo",
    countryIso3: "FRO",
    countryCode: "+298",
    phoneLength: 6,
    icon: FO,
  },
  fi: {
    name: "Finland",
    name_ar: "فنلندا",
    countryIso2: "fi",
    countryIso3: "FIN",
    countryCode: "+358",
    phoneLength: 11,
    icon: FI,
  },
  fr: {
    name: "France",
    name_ar: "فرنسا",
    countryIso2: "fr",
    countryIso3: "FRA",
    countryCode: "+33",
    phoneLength: 9,
    icon: FR,
  },
  gf: {
    name: "French Guiana",
    name_ar: "غويانا الفرنسية",
    countryIso2: "gf",
    countryIso3: "GUF",
    countryCode: "+594",
    phoneLength: 9,
    icon: Globe,
  },
  pf: {
    name: "French Polynesia",
    name_ar: "بولينيزيا الفرنسية",
    countryIso2: "pf",
    countryIso3: "PYF",
    countryCode: "+689",
    phoneLength: 8,
    icon: PF,
  },
  ga: {
    name: "Gabon",
    name_ar: "الغابون",
    countryIso2: "ga",
    countryIso3: "GAB",
    countryCode: "+241",
    phoneLength: 8,
    icon: GA,
  },
  gm: {
    name: "Gambia",
    name_ar: "غامبيا",
    countryIso2: "gm",
    countryIso3: "GMB",
    countryCode: "+220",
    phoneLength: 9,
    icon: GM,
  },
  ge: {
    name: "Georgia",
    name_ar: "جورجيا",
    countryIso2: "ge",
    countryIso3: "GEO",
    countryCode: "+995",
    phoneLength: 9,
    icon: GE,
  },
  de: {
    name: "Germany",
    name_ar: "ألمانيا",
    countryIso2: "de",
    countryIso3: "DEU",
    countryCode: "+49",
    phoneLength: 11,
    icon: DE,
  },
  gh: {
    name: "Ghana",
    name_ar: "غانا",
    countryIso2: "gh",
    countryIso3: "GHA",
    countryCode: "+233",
    phoneLength: 9,
    icon: GH,
  },
  gr: {
    name: "Greece",
    name_ar: "اليونان",
    countryIso2: "gr",
    countryIso3: "GRC",
    countryCode: "+30",
    phoneLength: 10,
    icon: GR,
  },
  gl: {
    name: "Greenland",
    name_ar: "غرينلاند",
    countryIso2: "gl",
    countryIso3: "GRL",
    countryCode: "+299",
    phoneLength: 6,
    icon: GL,
  },
  gd: {
    name: "Grenada",
    name_ar: "غرينادا",
    countryIso2: "gd",
    countryIso3: "GRD",
    countryCode: "+1",
    phoneLength: 10,
    icon: GD,
  },
  gp: {
    name: "Guadeloupe",
    name_ar: "غوادلوب",
    countryIso2: "gp",
    countryIso3: "GLP",
    countryCode: "+590",
    phoneLength: 9,
    icon: Globe,
  },
  gu: {
    name: "Guam",
    name_ar: "غوام",
    countryIso2: "gu",
    countryIso3: "GUM",
    countryCode: "+1",
    phoneLength: 10,
    icon: GU,
  },
  gt: {
    name: "Guatemala",
    name_ar: "غواتيمالا",
    countryIso2: "gt",
    countryIso3: "GTM",
    countryCode: "+502",
    phoneLength: 8,
    icon: GT,
  },
  gg: {
    name: "Guernsey",
    name_ar: "غيرنزي",
    countryIso2: "gg",
    countryIso3: "GGY",
    countryCode: "+44",
    phoneLength: 10,
    icon: GG,
  },
  gn: {
    name: "Guinea",
    name_ar: "غينيا",
    countryIso2: "gn",
    countryIso3: "GIN",
    countryCode: "+224",
    phoneLength: 9,
    icon: GN,
  },
  gw: {
    name: "Guinea-Bissau",
    name_ar: "غينيا بيساو",
    countryIso2: "gw",
    countryIso3: "GNB",
    countryCode: "+245",
    phoneLength: 9,
    icon: GW,
  },
  gy: {
    name: "Guyana",
    name_ar: "غيانا",
    countryIso2: "gy",
    countryIso3: "GUY",
    countryCode: "+592",
    phoneLength: 7,
    icon: GY,
  },
  ht: {
    name: "Haiti",
    name_ar: "هايتي",
    countryIso2: "ht",
    countryIso3: "HTI",
    countryCode: "+509",
    phoneLength: 8,
    icon: HT,
  },
  va: {
    name: "Vatican City State",
    name_ar: "الفاتيكان",
    countryIso2: "va",
    countryIso3: "VAT",
    countryCode: "+39",
    phoneLength: 10,
    icon: Globe,
  },
  hn: {
    name: "Honduras",
    name_ar: "هندوراس",
    countryIso2: "hn",
    countryIso3: "HND",
    countryCode: "+504",
    phoneLength: 8,
    icon: HN,
  },
  hu: {
    name: "Hungary",
    name_ar: "هنغاريا",
    countryIso2: "hu",
    countryIso3: "HUN",
    countryCode: "+36",
    phoneLength: 9,
    icon: HU,
  },
  is: {
    name: "Iceland",
    name_ar: "آيسلندا",
    countryIso2: "is",
    countryIso3: "ISL",
    countryCode: "+354",
    phoneLength: 9,
    icon: IS,
  },
  in: {
    name: "India",
    name_ar: "الهند",
    countryIso2: "in",
    countryIso3: "IND",
    countryCode: "+91",
    phoneLength: 10,
    icon: IN,
  },
  id: {
    name: "Indonesia",
    name_ar: "إندونيسيا",
    countryIso2: "id",
    countryIso3: "IDN",
    countryCode: "+62",
    phoneLength: 11,
    icon: ID,
  },
  ir: {
    name: "Iran",
    name_ar: "إيران",
    countryIso2: "ir",
    countryIso3: "IRN",
    countryCode: "+98",
    phoneLength: 10,
    icon: IR,
  },
  iq: {
    name: "Iraq",
    name_ar: "العراق",
    countryIso2: "iq",
    countryIso3: "IRQ",
    countryCode: "+964",
    phoneLength: 10,
    icon: IQ,
  },
  ie: {
    name: "Ireland",
    name_ar: "أيرلندا",
    countryIso2: "ie",
    countryIso3: "IRL",
    countryCode: "+353",
    phoneLength: 9,
    icon: IE,
  },
  it: {
    name: "Italy",
    name_ar: "إيطاليا",
    countryIso2: "it",
    countryIso3: "ITA",
    countryCode: "+39",
    phoneLength: 10,
    icon: IT,
  },
  jm: {
    name: "Jamaica",
    name_ar: "جامايكا",
    countryIso2: "jm",
    countryIso3: "JAM",
    countryCode: "+1",
    phoneLength: 10,
    icon: JM,
  },
  jp: {
    name: "Japan",
    name_ar: "اليابان",
    countryIso2: "jp",
    countryIso3: "JPN",
    countryCode: "+81",
    phoneLength: 10,
    icon: JP,
  },
  je: {
    name: "Jersey",
    name_ar: "جيرسي",
    countryIso2: "je",
    countryIso3: "JEY",
    countryCode: "+44",
    phoneLength: 10,
    icon: JE,
  },
  jo: {
    name: "Jordan",
    name_ar: "الأردن",
    countryIso2: "jo",
    countryIso3: "JOR",
    countryCode: "+962",
    phoneLength: 9,
    icon: JO,
  },
  kz: {
    name: "Kazakhstan",
    name_ar: "كازاخستان",
    countryIso2: "kz",
    countryIso3: "KAZ",
    countryCode: "+7",
    phoneLength: 10,
    icon: KZ,
  },
  ke: {
    name: "Kenya",
    name_ar: "كينيا",
    countryIso2: "ke",
    countryIso3: "KEN",
    countryCode: "+254",
    phoneLength: 9,
    icon: KE,
  },
  ki: {
    name: "Kiribati",
    name_ar: "كيريباتي",
    countryIso2: "ki",
    countryIso3: "KIR",
    countryCode: "+686",
    phoneLength: 8,
    icon: KI,
  },
  kp: {
    name: "North Korea",
    name_ar: "كوريا الشمالية",
    countryIso2: "kp",
    countryIso3: "PRK",
    countryCode: "+850",
    phoneLength: 10,
    icon: KP,
  },
  kr: {
    name: "South Korea",
    name_ar: "كوريا الجنوبية",
    countryIso2: "kr",
    countryIso3: "KOR",
    countryCode: "+82",
    phoneLength: 10,
    icon: KR,
  },
  kw: {
    name: "Kuwait",
    name_ar: "الكويت",
    countryIso2: "kw",
    countryIso3: "KWT",
    countryCode: "+965",
    phoneLength: 8,
    icon: KW,
  },
  lv: {
    name: "Latvia",
    name_ar: "لاتفيا",
    countryIso2: "lv",
    countryIso3: "LVA",
    countryCode: "+371",
    phoneLength: 8,
    icon: LV,
  },
  lb: {
    name: "Lebanon",
    name_ar: "لبنان",
    countryIso2: "lb",
    countryIso3: "LBN",
    countryCode: "+961",
    phoneLength: 8,
    icon: LB,
  },
  ls: {
    name: "Lesotho",
    name_ar: "ليسوتو",
    countryIso2: "ls",
    countryIso3: "LSO",
    countryCode: "+266",
    phoneLength: 8,
    icon: LS,
  },
  lr: {
    name: "Liberia",
    name_ar: "ليبيريا",
    countryIso2: "lr",
    countryIso3: "LBR",
    countryCode: "+231",
    phoneLength: 9,
    icon: LR,
  },
  ly: {
    name: "Libya",
    name_ar: "ليبيا",
    countryIso2: "ly",
    countryIso3: "LBY",
    countryCode: "+218",
    phoneLength: 9,
    icon: LY,
  },
  li: {
    name: "Liechtenstein",
    name_ar: "ليختنشتاين",
    countryIso2: "li",
    countryIso3: "LIE",
    countryCode: "+423",
    phoneLength: 9,
    icon: LI,
  },
  lt: {
    name: "Lithuania",
    name_ar: "ليتوانيا",
    countryIso2: "lt",
    countryIso3: "LTU",
    countryCode: "+370",
    phoneLength: 8,
    icon: LT,
  },
  lu: {
    name: "Luxembourg",
    name_ar: "لوكسمبورغ",
    countryIso2: "lu",
    countryIso3: "LUX",
    countryCode: "+352",
    phoneLength: 9,
    icon: LU,
  },
  mg: {
    name: "Madagascar",
    name_ar: "مدغشقر",
    countryIso2: "mg",
    countryIso3: "MDG",
    countryCode: "+261",
    phoneLength: 9,
    icon: MG,
  },
  mw: {
    name: "Malawi",
    name_ar: "ملاوي",
    countryIso2: "mw",
    countryIso3: "MWI",
    countryCode: "+265",
    phoneLength: 9,
    icon: MW,
  },
  my: {
    name: "Malaysia",
    name_ar: "ماليزيا",
    countryIso2: "my",
    countryIso3: "MYS",
    countryCode: "+60",
    phoneLength: 10,
    icon: MY,
  },
  mv: {
    name: "Maldives",
    name_ar: "جزر المالديف",
    countryIso2: "mv",
    countryIso3: "MDV",
    countryCode: "+960",
    phoneLength: 7,
    icon: MV,
  },
  ml: {
    name: "Mali",
    name_ar: "مالي",
    countryIso2: "ml",
    countryIso3: "MLI",
    countryCode: "+223",
    phoneLength: 8,
    icon: ML,
  },
  mt: {
    name: "Malta",
    name_ar: "مالطا",
    countryIso2: "mt",
    countryIso3: "MLT",
    countryCode: "+356",
    phoneLength: 8,
    icon: MT,
  },
  mr: {
    name: "Mauritania",
    name_ar: "موريتانيا",
    countryIso2: "mr",
    countryIso3: "MRT",
    countryCode: "+222",
    phoneLength: 8,
    icon: MR,
  },
  mu: {
    name: "Mauritius",
    name_ar: "موريشيوس",
    countryIso2: "mu",
    countryIso3: "MUS",
    countryCode: "+230",
    phoneLength: 8,
    icon: MU,
  },
  yt: {
    name: "Mayotte",
    name_ar: "مايوت",
    countryIso2: "yt",
    countryIso3: "MYT",
    countryCode: "+262",
    phoneLength: 9,
    icon: Globe,
  },
  mx: {
    name: "Mexico",
    name_ar: "المكسيك",
    countryIso2: "mx",
    countryIso3: "MEX",
    countryCode: "+52",
    phoneLength: 10,
    icon: MX,
  },
  fm: {
    name: "Micronesia",
    name_ar: "ميكرونيزيا",
    countryIso2: "fm",
    countryIso3: "FSM",
    countryCode: "+691",
    phoneLength: 7,
    icon: FM,
  },
  md: {
    name: "Moldova",
    name_ar: "مولدوفا",
    countryIso2: "md",
    countryIso3: "MDA",
    countryCode: "+373",
    phoneLength: 8,
    icon: MD,
  },
  mc: {
    name: "Monaco",
    name_ar: "موناكو",
    countryIso2: "mc",
    countryIso3: "MCO",
    countryCode: "+377",
    phoneLength: 9,
    icon: MC,
  },
  mn: {
    name: "Mongolia",
    name_ar: "منغوليا",
    countryIso2: "mn",
    countryIso3: "MNG",
    countryCode: "+976",
    phoneLength: 8,
    icon: MN,
  },
  me: {
    name: "Montenegro",
    name_ar: "الجبل الأسود",
    countryIso2: "me",
    countryIso3: "MNE",
    countryCode: "+382",
    phoneLength: 8,
    icon: ME,
  },
  ms: {
    name: "Montserrat",
    name_ar: "مونتسرات",
    countryIso2: "ms",
    countryIso3: "MSR",
    countryCode: "+1",
    phoneLength: 10,
    icon: MS,
  },
  ma: {
    name: "Morocco",
    name_ar: "المغرب",
    countryIso2: "ma",
    countryIso3: "MAR",
    countryCode: "+212",
    phoneLength: 9,
    icon: MA,
  },
  mz: {
    name: "Mozambique",
    name_ar: "موزمبيق",
    countryIso2: "mz",
    countryIso3: "MOZ",
    countryCode: "+258",
    phoneLength: 9,
    icon: MZ,
  },
  mm: {
    name: "Myanmar",
    name_ar: "ميانمار (بورما)",
    countryIso2: "mm",
    countryIso3: "MMR",
    countryCode: "+95",
    phoneLength: 11,
    icon: MM,
  },
  na: {
    name: "Namibia",
    name_ar: "ناميبيا",
    countryIso2: "na",
    countryIso3: "NAM",
    countryCode: "+264",
    phoneLength: 9,
    icon: NA,
  },
  nr: {
    name: "Nauru",
    name_ar: "ناورو",
    countryIso2: "nr",
    countryIso3: "NRU",
    countryCode: "+674",
    phoneLength: 7,
    icon: NR,
  },
  np: {
    name: "Nepal",
    name_ar: "نيبال",
    countryIso2: "np",
    countryIso3: "NPL",
    countryCode: "+977",
    phoneLength: 10,
    icon: NP,
  },
  nl: {
    name: "Netherlands",
    name_ar: "هولندا",
    countryIso2: "nl",
    countryIso3: "NLD",
    countryCode: "+31",
    phoneLength: 11,
    icon: NL,
  },
  nc: {
    name: "New Caledonia",
    name_ar: "كاليدونيا الجديدة",
    countryIso2: "nc",
    countryIso3: "NCL",
    countryCode: "+687",
    phoneLength: 6,
    icon: Globe,
  },
  nz: {
    name: "New Zealand",
    name_ar: "نيوزيلندا",
    countryIso2: "nz",
    countryIso3: "NZL",
    countryCode: "+64",
    phoneLength: 11,
    icon: NZ,
  },
  ni: {
    name: "Nicaragua",
    name_ar: "نيكاراغوا",
    countryIso2: "ni",
    countryIso3: "NIC",
    countryCode: "+505",
    phoneLength: 8,
    icon: NI,
  },
  ne: {
    name: "Niger",
    name_ar: "النيجر",
    countryIso2: "ne",
    countryIso3: "NER",
    countryCode: "+227",
    phoneLength: 8,
    icon: NE,
  },
  ng: {
    name: "Nigeria",
    name_ar: "نيجيريا",
    countryIso2: "ng",
    countryIso3: "NGA",
    countryCode: "+234",
    phoneLength: 10,
    icon: NG,
  },
  nu: {
    name: "Niue",
    name_ar: "نيوي",
    countryIso2: "nu",
    countryIso3: "NIU",
    countryCode: "+683",
    phoneLength: 7,
    icon: NU,
  },
  mp: {
    name: "Northern Mariana Islands",
    name_ar: "جزر ماريانا الشمالية",
    countryIso2: "mp",
    countryIso3: "MNP",
    countryCode: "+1",
    phoneLength: 10,
    icon: MP,
  },
  no: {
    name: "Norway",
    name_ar: "النرويج",
    countryIso2: "no",
    countryIso3: "NOR",
    countryCode: "+47",
    phoneLength: 8,
    icon: NO,
  },
  om: {
    name: "Oman",
    name_ar: "عُمان",
    countryIso2: "om",
    countryIso3: "OMN",
    countryCode: "+968",
    phoneLength: 8,
    icon: OM,
  },
  pk: {
    name: "Pakistan",
    name_ar: "باكستان",
    countryIso2: "pk",
    countryIso3: "PAK",
    countryCode: "+92",
    phoneLength: 10,
    icon: PK,
  },
  pw: {
    name: "Palau",
    name_ar: "بالاو",
    countryIso2: "pw",
    countryIso3: "PLW",
    countryCode: "+680",
    phoneLength: 7,
    icon: PW,
  },
  ps: {
    name: "Palestine",
    name_ar: "فلسطين",
    countryIso2: "ps",
    countryIso3: "PSE",
    countryCode: "+970",
    phoneLength: 9,
    icon: PS,
  },
  pa: {
    name: "Panama",
    name_ar: "بنما",
    countryIso2: "pa",
    countryIso3: "PAN",
    countryCode: "+507",
    phoneLength: 8,
    icon: PA,
  },
  pg: {
    name: "Papua New Guinea",
    name_ar: "بابوا غينيا الجديدة",
    countryIso2: "pg",
    countryIso3: "PNG",
    countryCode: "+675",
    phoneLength: 8,
    icon: PG,
  },
  py: {
    name: "Paraguay",
    name_ar: "باراغواي",
    countryIso2: "py",
    countryIso3: "PRY",
    countryCode: "+595",
    phoneLength: 9,
    icon: PY,
  },
  pe: {
    name: "Peru",
    name_ar: "بيرو",
    countryIso2: "pe",
    countryIso3: "PER",
    countryCode: "+51",
    phoneLength: 9,
    icon: PE,
  },
  ph: {
    name: "Philippines",
    name_ar: "الفلبين",
    countryIso2: "ph",
    countryIso3: "PHL",
    countryCode: "+63",
    phoneLength: 10,
    icon: PH,
  },
  pn: {
    name: "Pitcairn",
    name_ar: "جزر بيتكيرن",
    countryIso2: "pn",
    countryIso3: "PCN",
    countryCode: "+64",
    phoneLength: 11,
    icon: PN,
  },
  pl: {
    name: "Poland",
    name_ar: "بولندا",
    countryIso2: "pl",
    countryIso3: "POL",
    countryCode: "+48",
    phoneLength: 9,
    icon: PL,
  },
  pt: {
    name: "Portugal",
    name_ar: "البرتغال",
    countryIso2: "pt",
    countryIso3: "PRT",
    countryCode: "+351",
    phoneLength: 9,
    icon: PT,
  },
  pr: {
    name: "Puerto Rico",
    name_ar: "بورتوريكو",
    countryIso2: "pr",
    countryIso3: "PRI",
    countryCode: "+1",
    phoneLength: 10,
    icon: PR,
  },
  qa: {
    name: "Qatar",
    name_ar: "قطر",
    countryIso2: "qa",
    countryIso3: "QAT",
    countryCode: "+974",
    phoneLength: 8,
    icon: QA,
  },
  ro: {
    name: "Romania",
    name_ar: "رومانيا",
    countryIso2: "ro",
    countryIso3: "ROU",
    countryCode: "+40",
    phoneLength: 9,
    icon: RO,
  },
  ru: {
    name: "Russian Federation",
    name_ar: "روسيا",
    countryIso2: "ru",
    countryIso3: "RUS",
    countryCode: "+7",
    phoneLength: 10,
    icon: RU,
  },
  rw: {
    name: "Rwanda",
    name_ar: "رواندا",
    countryIso2: "rw",
    countryIso3: "RWA",
    countryCode: "+250",
    phoneLength: 9,
    icon: RW,
  },
  re: {
    name: "Réunion",
    name_ar: "روينيون",
    countryIso2: "re",
    countryIso3: "REU",
    countryCode: "+262",
    phoneLength: 9,
    icon: Globe,
  },
  bl: {
    name: "Saint Barthélemy",
    name_ar: "سان بارتليمي",
    countryIso2: "bl",
    countryIso3: "BLM",
    countryCode: "+590",
    phoneLength: 9,
    icon: BL,
  },
  lc: {
    name: "Saint Lucia",
    name_ar: "سانت لوسيا",
    countryIso2: "lc",
    countryIso3: "LCA",
    countryCode: "+1",
    phoneLength: 10,
    icon: LC,
  },
  mf: {
    name: "Saint Martin",
    name_ar: "سان مارتن",
    countryIso2: "mf",
    countryIso3: "MAF",
    countryCode: "+590",
    phoneLength: 9,
    icon: Globe,
  },
  ws: {
    name: "Samoa",
    name_ar: "ساموا",
    countryIso2: "ws",
    countryIso3: "WSM",
    countryCode: "+685",
    phoneLength: 10,
    icon: WS,
  },
  sm: {
    name: "San Marino",
    name_ar: "سان مارينو",
    countryIso2: "sm",
    countryIso3: "SMR",
    countryCode: "+378",
    phoneLength: 8,
    icon: SM,
  },
  sa: {
    name: "Saudi Arabia",
    name_ar: "المملكة العربية السعودية",
    countryIso2: "sa",
    countryIso3: "SAU",
    countryCode: "+966",
    phoneLength: 9,
    icon: SA,
  },
  sn: {
    name: "Senegal",
    name_ar: "السنغال",
    countryIso2: "sn",
    countryIso3: "SEN",
    countryCode: "+221",
    phoneLength: 9,
    icon: SN,
  },
  rs: {
    name: "Serbia",
    name_ar: "صربيا",
    countryIso2: "rs",
    countryIso3: "SRB",
    countryCode: "+381",
    phoneLength: 11,
    icon: RS,
  },
  sc: {
    name: "Seychelles",
    name_ar: "سيشل",
    countryIso2: "sc",
    countryIso3: "SYC",
    countryCode: "+248",
    phoneLength: 7,
    icon: SC,
  },
  sl: {
    name: "Sierra Leone",
    name_ar: "سيراليون",
    countryIso2: "sl",
    countryIso3: "SLE",
    countryCode: "+232",
    phoneLength: 8,
    icon: SL,
  },
  sg: {
    name: "Singapore",
    name_ar: "سنغافورة",
    countryIso2: "sg",
    countryIso3: "SGP",
    countryCode: "+65",
    phoneLength: 8,
    icon: SG,
  },
  sx: {
    name: "Sint Maarten",
    name_ar: "سانت مارتن",
    countryIso2: "sx",
    countryIso3: "SXM",
    countryCode: "+1",
    phoneLength: 10,
    icon: SX,
  },
  sk: {
    name: "Slovakia",
    name_ar: "سلوفاكيا",
    countryIso2: "sk",
    countryIso3: "SVK",
    countryCode: "+421",
    phoneLength: 9,
    icon: SK,
  },
  si: {
    name: "Slovenia",
    name_ar: "سلوفينيا",
    countryIso2: "si",
    countryIso3: "SVN",
    countryCode: "+386",
    phoneLength: 8,
    icon: SI,
  },
  so: {
    name: "Somalia",
    name_ar: "الصومال",
    countryIso2: "so",
    countryIso3: "SOM",
    countryCode: "+252",
    phoneLength: 11,
    icon: SO,
  },
  za: {
    name: "South Africa",
    name_ar: "جنوب أفريقيا",
    countryIso2: "za",
    countryIso3: "ZAF",
    countryCode: "+27",
    phoneLength: 11,
    icon: ZA,
  },
  ss: {
    name: "South Sudan",
    name_ar: "جنوب السودان",
    countryIso2: "ss",
    countryIso3: "SSD",
    countryCode: "+211",
    phoneLength: 9,
    icon: SS,
  },
  es: {
    name: "Spain",
    name_ar: "إسبانيا",
    countryIso2: "es",
    countryIso3: "ESP",
    countryCode: "+34",
    phoneLength: 9,
    icon: ES,
  },
  lk: {
    name: "Sri Lanka",
    name_ar: "سريلانكا",
    countryIso2: "lk",
    countryIso3: "LKA",
    countryCode: "+94",
    phoneLength: 9,
    icon: LK,
  },
  sd: {
    name: "Sudan",
    name_ar: "السودان",
    countryIso2: "sd",
    countryIso3: "SDN",
    countryCode: "+249",
    phoneLength: 9,
    icon: Globe,
  },
  sr: {
    name: "Suriname",
    name_ar: "سورينام",
    countryIso2: "sr",
    countryIso3: "SUR",
    countryCode: "+597",
    phoneLength: 7,
    icon: SR,
  },
  se: {
    name: "Sweden",
    name_ar: "السويد",
    countryIso2: "se",
    countryIso3: "SWE",
    countryCode: "+46",
    phoneLength: 9,
    icon: SE,
  },
  ch: {
    name: "Switzerland",
    name_ar: "سويسرا",
    countryIso2: "ch",
    countryIso3: "CHE",
    countryCode: "+41",
    phoneLength: 9,
    icon: CH,
  },
  sy: {
    name: "Syria",
    name_ar: "سوريا",
    countryIso2: "sy",
    countryIso3: "SYR",
    countryCode: "+963",
    phoneLength: 9,
    icon: SY,
  },
  tw: {
    name: "Taiwan",
    name_ar: "تايوان",
    countryIso2: "tw",
    countryIso3: "TWN",
    countryCode: "+886",
    phoneLength: 9,
    icon: TW,
  },
  tj: {
    name: "Tajikistan",
    name_ar: "طاجيكستان",
    countryIso2: "tj",
    countryIso3: "TJK",
    countryCode: "+992",
    phoneLength: 9,
    icon: TJ,
  },
  tz: {
    name: "Tanzania",
    name_ar: "تنزانيا",
    countryIso2: "tz",
    countryIso3: "TZA",
    countryCode: "+255",
    phoneLength: 9,
    icon: TZ,
  },
  th: {
    name: "Thailand",
    name_ar: "تايلاند",
    countryIso2: "th",
    countryIso3: "THA",
    countryCode: "+66",
    phoneLength: 9,
    icon: TH,
  },
  tg: {
    name: "Togo",
    name_ar: "توغو",
    countryIso2: "tg",
    countryIso3: "TGO",
    countryCode: "+228",
    phoneLength: 8,
    icon: TG,
  },
  tk: {
    name: "Tokelau",
    name_ar: "توكيلاو",
    countryIso2: "tk",
    countryIso3: "TKL",
    countryCode: "+690",
    phoneLength: 11,
    icon: TK,
  },
  to: {
    name: "Tonga",
    name_ar: "تونغا",
    countryIso2: "to",
    countryIso3: "TON",
    countryCode: "+676",
    phoneLength: 7,
    icon: TO,
  },
  tt: {
    name: "Trinidad and Tobago",
    name_ar: "ترينيداد وتوباغو",
    countryIso2: "tt",
    countryIso3: "TTO",
    countryCode: "+1",
    phoneLength: 10,
    icon: TT,
  },
  tn: {
    name: "Tunisia",
    name_ar: "تونس",
    countryIso2: "tn",
    countryIso3: "TUN",
    countryCode: "+216",
    phoneLength: 8,
    icon: TN,
  },
  tm: {
    name: "Turkmenistan",
    name_ar: "تركمانستان",
    countryIso2: "tm",
    countryIso3: "TKM",
    countryCode: "+993",
    phoneLength: 8,
    icon: TM,
  },
  tv: {
    name: "Tuvalu",
    name_ar: "توفالو",
    countryIso2: "tv",
    countryIso3: "TUV",
    countryCode: "+688",
    phoneLength: 7,
    icon: TV,
  },
  tr: {
    name: "Türkiye",
    name_ar: "تركيا",
    countryIso2: "tr",
    countryIso3: "TUR",
    countryCode: "+90",
    phoneLength: 10,
    icon: TR,
  },
  ug: {
    name: "Uganda",
    name_ar: "أوغندا",
    countryIso2: "ug",
    countryIso3: "UGA",
    countryCode: "+256",
    phoneLength: 9,
    icon: UG,
  },
  ua: {
    name: "Ukraine",
    name_ar: "أوكرانيا",
    countryIso2: "ua",
    countryIso3: "UKR",
    countryCode: "+380",
    phoneLength: 9,
    icon: UA,
  },
  ae: {
    name: "United Arab Emirates",
    name_ar: "الإمارات العربية المتحدة",
    countryIso2: "ae",
    countryIso3: "ARE",
    countryCode: "+971",
    phoneLength: 9,
    icon: AE,
  },
  gb: {
    name: "United Kingdom",
    name_ar: "المملكة المتحدة",
    countryIso2: "gb",
    countryIso3: "GBR",
    countryCode: "+44",
    phoneLength: 10,
    icon: GB,
  },
  us: {
    name: "United States",
    name_ar: "الولايات المتحدة",
    countryIso2: "us",
    countryIso3: "USA",
    countryCode: "+1",
    phoneLength: 10,
    icon: US,
  },
  uy: {
    name: "Uruguay",
    name_ar: "أورغواي",
    countryIso2: "uy",
    countryIso3: "URY",
    countryCode: "+598",
    phoneLength: 8,
    icon: UY,
  },
  uz: {
    name: "Uzbekistan",
    name_ar: "أوزبكستان",
    countryIso2: "uz",
    countryIso3: "UZB",
    countryCode: "+998",
    phoneLength: 9,
    icon: UZ,
  },
  vu: {
    name: "Vanuatu",
    name_ar: "فانواتو",
    countryIso2: "vu",
    countryIso3: "VUT",
    countryCode: "+678",
    phoneLength: 7,
    icon: VU,
  },
  ve: {
    name: "Venezuela",
    name_ar: "فنزويلا",
    countryIso2: "ve",
    countryIso3: "VEN",
    countryCode: "+58",
    phoneLength: 10,
    icon: VE,
  },
  vn: {
    name: "Viet Nam",
    name_ar: "فيتنام",
    countryIso2: "vn",
    countryIso3: "VNM",
    countryCode: "+84",
    phoneLength: 9,
    icon: VN,
  },
  ye: {
    name: "Yemen",
    name_ar: "اليمن",
    countryIso2: "ye",
    countryIso3: "YEM",
    countryCode: "+967",
    phoneLength: 9,
    icon: YE,
  },
  zm: {
    name: "Zambia",
    name_ar: "زامبيا",
    countryIso2: "zm",
    countryIso3: "ZMB",
    countryCode: "+260",
    phoneLength: 9,
    icon: ZM,
  },
  zw: {
    name: "Zimbabwe",
    name_ar: "زيمبابوي",
    countryIso2: "zw",
    countryIso3: "ZWE",
    countryCode: "+263",
    phoneLength: 9,
    icon: ZW,
  },
};
